import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scrollear al top de forma suave
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto", // o 'auto' para scroll instantáneo
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
